import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAccessControlActionList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("AccessCtrlActionRequire/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class ConfirmAccessControlAction extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("AccessCtrlActionRequire/Confirm");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export { GetAccessControlActionList, ConfirmAccessControlAction };
